import xhr from "xhr";

export default function () {
    document.addEventListener("DOMContentLoaded", () => {
        const gtmPush = (form) => {
            dataLayer.push({
                event: "Form Submit",
                formName: "Contact Us",
                formID: form.id,
            });
        };

        const form = document.querySelector("form[action='/contact-us/Form']");

        if (form) {
            form.addEventListener("submit", (e) => {
                e.preventDefault();
                const formValidated = form.reportValidity()
                if (formValidated) {
                    console.log("valid", formValidated);
                    gtmPush(form);
                } else {
                    console.log("invlaid", formValidated);
                }
            });
        }
    });
}

